import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const ReportsList = lazyLoader(
  () => import("Containers/Reports/ReportsList/ReportsList")
);
export const Reports = () => {
  return (
    <Layout>
      <ReportsList />
    </Layout>
  );
};
